// Exclusión de pares NC↔factura con `tipo_relacion_nc = 'anula_error'` (regla 10.221 / 10.222).
//
// Una NC `anula_error` cancela por completo el documento que referencia (fue un error, se reemitió):
// la NC Y la factura anulada deben quedar FUERA de todo cálculo de deuda/saldo/por-pagar, en
// cualquier mes — exactamente como ya lo hace costosER.js del lado del ER. `ajuste_comercial` NO se
// toca (la NC resta normal, el documento referenciado cuenta normal). Una NC sin `documento_referenciado_id`
// (sin vincular) tampoco entra acá: su exclusión, si aplica, la maneja cada consumidor (el predicado
// de "por pagar" ya descarta TODA NC por `tipo_dte === 61`).
//
// Función PURA: recibe el universo de facturas SII recibidas (incluyendo las NC, que son filas
// `tipo_dte = 61` de la misma tabla) y devuelve dos Sets de IDs. Comparar/guardar por ID (regla 10.7).

import { esNotaCredito } from "./dte";

export const construirExclusionNcAnulaError = (facturas = []) => {
  const facturasAnuladas = new Set(); // ids de facturas anuladas (el `documento_referenciado_id` de la NC)
  const notasCredito = new Set(); // ids de las NC `anula_error` que anulan
  for (const f of facturas || []) {
    if (!esNotaCredito(f)) continue;
    if (f?.tipo_relacion_nc !== "anula_error") continue;
    const refId = f?.documento_referenciado_id;
    if (refId == null) continue; // NC sin vincular: no forma par de anulación
    notasCredito.add(Number(f.id));
    facturasAnuladas.add(Number(refId));
  }
  return { facturasAnuladas, notasCredito };
};
